const QUESTION_TYPES = ['text_area', 'multiple_choice', 'multi_select', 'scored'];

export default QUESTION_TYPES;
